import { Schema } from "effect";
import { ResourceWorkspaceId } from "@workerstation/shared/resources/http";
import { WorkflowClassName, WorkflowHttpInstanceId } from "@workerstation/shared/resources/workflow";
import type { WorkflowCatalog, WorkflowPublicInstance } from "@workerstation/shared/resources/workflow";
export type WorkflowDefinition = WorkflowCatalog["definitions"][number];
export type WorkflowInstance = WorkflowPublicInstance;
export type WorkflowStep = WorkflowInstance["steps"][number];
export type WorkflowSourceStep = WorkflowDefinition["steps"][number];
export type WorkflowSnapshot = WorkflowCatalog;
export const WorkflowDefinitionTarget = Schema.Struct({ workspaceId: Schema.String, className: Schema.String });
export type WorkflowDefinitionTarget = typeof WorkflowDefinitionTarget.Type;
export const WorkflowInstanceTarget = Schema.Struct({ workspaceId: Schema.String, instanceId: Schema.String });
export type WorkflowInstanceTarget = typeof WorkflowInstanceTarget.Type;
export const PreparedDefinitionTarget = Schema.Struct({ workspaceId: ResourceWorkspaceId, className: WorkflowClassName });
export const PreparedInstanceTarget = Schema.Struct({ workspaceId: ResourceWorkspaceId, instanceId: WorkflowHttpInstanceId });
export type WorkflowDefinitionRecord = WorkflowDefinition;
export type WorkflowInstanceRecord = WorkflowInstance;
export type WorkflowStepRecord = WorkflowStep;
export type WorkflowWorkspaceSnapshot = WorkflowSnapshot;
